export const NAME = 'ui'

export const DEBOUNCE_TIME = 300
